import React from 'react';
import { Shape } from '../../../../Game/Level/Blok';
import { BlockAppearanceTypes } from '../../../shared';

import LibraryManager from '../../../../Game/Base/Library/LibraryManager';

import RangeSlider from '../../Default/RangeSlider';
import RadioButton from '../../Default/RadioButton';
import ColorPicker from '../../Default/ColorPicker';
import AssetPickerLink from '../../AssetPicker/AssetPickerLink';
import LibraryTypeEnum from '../../../../Game/Base/Library/Enums';

import { displayNumber } from '../../../helpers/numberHelpers';

export default function Appearance({ shape, data, updateShape, updateBlokStateLook, changeState, assetHistory }) {
    return (
        <div className="side-bar-page-content">
            {!changeState && (
                <>
                    <div className="side-bar-row side-bar-row-appearance">
                        <RadioButton style={{ width: '50%' }} name="shape" value={Shape.rectangle} activeValue={shape} onChange={updateShape}>
                            <div className={`side-bar-square${shape === Shape.rectangle ? ' side-bar-shape-active' : ''}`} />
                        </RadioButton>
                        <RadioButton style={{ width: '50%' }} name="shape" value={Shape.circle} activeValue={shape} onChange={updateShape}>
                            <div className={`side-bar-circle${shape === Shape.circle ? ' side-bar-shape-active' : ''}`} />
                        </RadioButton>
                    </div>
                    <hr />
                </>
            )}
            <div className="side-bar-row side-bar-row-title">Vulling</div>
            <div className="side-bar-row side-bar-row-vulling">
                <RadioButton style={{ width: '50%' }} name="texture" value={BlockAppearanceTypes.TEXTURE} activeValue={data.type} onChange={e => updateBlokStateLook(parseInt(e.target.value, 10), {})}>
                    Plaatje
                </RadioButton>
                <RadioButton style={{ width: '50%' }} name="texture" value={BlockAppearanceTypes.TEXT} activeValue={data.type} onChange={e => updateBlokStateLook(parseInt(e.target.value, 10), {})}>
                    Tekst
                </RadioButton>
            </div>
            {data.type === BlockAppearanceTypes.TEXTURE ? (
                <>
                    <div className="side-bar-row">
                        <div className="assetpicker-history">
                            {assetHistory.length > 0 &&
                                assetHistory.map(id => (
                                    <div
                                        key={id}
                                        tabIndex={-1}
                                        role="button"
                                        className={`assetpicker-history-item${id === data.value ? ' assetpicker-history-item-active' : ''}`}
                                        onClick={() => {
                                            updateBlokStateLook(data.type, {
                                                ...data,
                                                value: id
                                            });
                                        }}
                                        onKeyDown={() => {
                                            updateBlokStateLook(data.type, {
                                                ...data,
                                                value: id
                                            });
                                        }}
                                    >
                                        <img src={LibraryManager.textures.get(id).get().baseTexture.imageUrl} alt={id} />
                                    </div>
                                ))}
                        </div>
                        <AssetPickerLink
                            id="gameblok-ui-blok-picker"
                            type={LibraryTypeEnum.TEXTURES}
                            postCheckbox="meer"
                            currentAsset={data.value}
                            onPickAsset={value => {
                                updateBlokStateLook(data.type, {
                                    ...data,
                                    value
                                });
                            }}
                        />
                    </div>
                    <div className="side-bar-row side-bar-row-title">Verkleuren</div>
                    <div className="side-bar-row">
                        <RangeSlider
                            min={0}
                            max={359}
                            step={0.1}
                            currentValue={data.hue}
                            onChange={hue =>
                                updateBlokStateLook(data.type, {
                                    ...data,
                                    hue
                                })
                            }
                            background="linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)"
                            hideValues
                        />
                    </div>
                </>
            ) : (
                <div>
                    <div className="side-bar-row">
                        <textarea
                            className="textarea"
                            placeholder="Tekst"
                            value={data.text}
                            onChange={e => {
                                updateBlokStateLook(data.type, {
                                    ...data,
                                    text: e.target.value
                                });
                            }}
                        ></textarea>
                    </div>
                    <div className="side-bar-row side-bar-row-title">Tekst kleur</div>
                    <div className="side-bar-row">
                        <ColorPicker
                            color={data.color.toString(16).padStart(6, '0')}
                            onChange={color => {
                                const colorValue = parseInt(color, 16);
                                updateBlokStateLook(data.type, {
                                    ...data,
                                    color: colorValue
                                });
                            }}
                        />
                    </div>
                    <div className="side-bar-row">Tekst grootte</div>
                    <div className="side-bar-row">
                        <div className="range-slider-container">
                            <div className="range-slider">
                                <RangeSlider
                                    hideValues
                                    currentValue={data.size}
                                    min={1}
                                    max={100}
                                    step={1}
                                    sliderStep={5}
                                    onChange={v => {
                                        updateBlokStateLook(data.type, {
                                            ...data,
                                            size: parseInt(v, 10)
                                        });
                                    }}
                                />
                            </div>
                            <div className="slider-value">{displayNumber(data.size, 0)}</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
